export const selectPositions = state => state.positions;
